import type { FunctionComponent, PropsWithChildren } from 'react'

import SavingsCalculator from '../../../components/savings-calculator'
import type { FormProps } from '../props'
import styles from './savings-calculator.module.scss'
import { Markdown } from '@components/markdown'
import { Text } from '@components/text'
import type { StepActionFragment } from '@graphql/fragments/StepsFragment.graphql'

export const SavingsCalculatorForm: FunctionComponent<
    PropsWithChildren<FormProps<any>>
> = ({ title, subtitle, meta }) => {
    const { savingsRate, successMessage, action, anchorId } =
        meta as unknown as {
            savingsRate: number
            successMessage: string
            action: StepActionFragment
            anchorId?: string
        }

    return (
        <>
            <div className={styles.container} id={anchorId}>
                <div className={styles.copy}>
                    <Markdown
                        tag='h2'
                        typeStyle={{
                            _: 'heading-sm',
                            md: 'heading-xl',
                        }}
                        markdown={title}
                        color='white'
                    />
                    <Text className={styles.supportingText} tag='div'>
                        {subtitle}
                    </Text>
                </div>
                <div className={styles.form}>
                    <SavingsCalculator
                        savingsRate={savingsRate}
                        successMessage={successMessage}
                        action={action}
                    />
                </div>
            </div>
        </>
    )
}
